import { Api, ApiRequest, ResType } from '@api'
import { Logger } from '@utils'

export const addInquiry = async ({
	params = {},
	body = {},
	query = {},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = '/inquiry'
		const req = new ApiRequest({
			method: 'post',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
			isRequiredToken: false,
		})

		const result: ResType = await Api.connection(req)

		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

// todo: 리턴 타입 정의
export const getInquiry = async ({
	params = {},
	body = {},
	query = {},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = '/inquiry'
		const req = new ApiRequest({
			method: 'get',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
		})

		const result: ResType = await Api.connection(req)

		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

export const deleteInquiry = async ({
	params = { inquiryId: '' },
	body = {},
	query = {},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = `/inquiry/${params.inquiryId}`
		const req = new ApiRequest({
			method: 'delete',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
		})

		const result: ResType = await Api.connection(req)

		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

// body 부분 필요하면 수정하기
export const updateInquiry = async ({
	params = { inquiryId: '' },
	body = { code: '', name: '', usd: 0, index: 0, useYn: 0 },
	query = {},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = `/inquiry/${params.inquiryId}`
		const req = new ApiRequest({
			method: 'put',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
		})

		const result: ResType = await Api.connection(req)

		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

const productApi = {
	addInquiry: addInquiry,
	getInquiry: getInquiry,
	deleteInquiry: deleteInquiry,
	updateInquiry: updateInquiry,
}

export default productApi
